import { AxiosError } from 'axios'
import { axiosInstance } from '@methods/axiosConfig'
import { API_URL, JOINTSIGNING_SERVICE_PATH, ONBOARDING_SERVICE_PATH } from '@constants/apiUrl'
import { NODE_ENV } from '@/constants/envs'
import { rootStore } from '@store/Root.store'

// Requests that may legitimately return 401/403 and are handled by the caller.
// The joint-signing context is fetched on success pages of plain onboarding flows too,
// where no joint-signing session exists, so a 401 there must not expire the session.
const EXCLUDE_URLS = ['kontomatik/check-status', `${JOINTSIGNING_SERVICE_PATH}/get-context`]
const REDIRECT_STATUS_CODES = [401, 403]

export const setupAxiosInterceptors = () => {
  axiosInstance.interceptors.response.use(undefined, async (error: AxiosError) => {
    const { themeId } = rootStore.InterfaceState
    const { language } = rootStore.TranslationsState

    if (
      !window.location.pathname.includes('error') &&
      !EXCLUDE_URLS.some((v) => error?.config?.url?.includes(v))
    ) {
      if (
        error.response &&
        REDIRECT_STATUS_CODES.includes(error.response.status) &&
        NODE_ENV === 'production'
      ) {
        window.location.replace(
          `${API_URL}/${ONBOARDING_SERVICE_PATH}/session-unauthorized?themeId=${themeId}&language=${language}`
        )
      }
    }
    return Promise.reject(error)
  })
}
